import React, { useState } from "react";
import "../style/Frames.css";

const frames = [
  { id: 1, img: "/frames/A.JPG" },
  { id: 2, img: "/frames/B.JPG" },
  { id: 3, img: "/frames/C.JPG" },
  { id: 4, img: "/frames/D.JPG" },
  { id: 5, img: "/frames/E.JPG" },
  { id: 6, img: "/frames/F.JPG" },
  { id: 7, img: "/frames/G.JPG" },
  { id: 8, img: "/frames/H.JPG" },
  { id: 9, img: "/frames/I.JPG" },
  { id: 10, img: "/frames/J.JPG" }
];

export default function Frames() {
  const [visible, setVisible] = useState(6);

  return (
    <section className="frames-section">
      <div className="frames-header">
        
        <h1>Photo Frames</h1>
        <p>
          Explore our modern and luxury photo frame designs crafted with
          premium finishing and elegant styling.
        </p>
      </div>

      <div className="frames-grid">
        {frames.slice(0, visible).map((frame) => (
          <div className="frame-item" key={frame.id}>
            <img src={frame.img} alt="frame" />
          </div>
        ))}
      </div>

      {visible < frames.length && (
        <div className="frames-btn-wrap">
          <button
            className="frames-btn"
            onClick={() => setVisible((prev) => prev + 4)}
          >
            View More
          </button>
        </div>
      )}
    </section>
  );
}